import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, map, Observable, take} from "rxjs";
import {environment} from "../../environments/environment";
import {Story} from "../interfaces/story";
import {Apollo, QueryRef} from "apollo-angular";
import {GET_PROFESSION_BY_ID} from "../queries/GET_PROFESSION_BY_ID";
import {GET_PROFESSIONS} from "../queries/GET_PROFESSIONS";
import {JobRequirementsService} from "./job-requirements.service";
import {ProfessionPreview} from "../interfaces/profession-preview";
import {GET_ALL_JOB_REQUIREMENT_TYPES} from "../queries/GET_ALL_JOB_REQUIREMENT_TYPES";
import {GetAllJobRequirementTypes} from "../queries/__generated__/GetAllJobRequirementTypes";
import {RequirementTypesList} from "../interfaces/requirement-types-list";
import {ProvidersService} from "./providers.service";
import {GetProfessionById} from "../queries/__generated__/GetProfessionById";
import {GetProfessions} from "../queries/__generated__/GetProfessions";
import {ProfessionsService} from "./professions.service";
import {GET_COMPANY_PROFILE_BY_ID} from "../queries/GET_COMPANY_PROFILE_BY_ID";
import {GetCompanyProfileById} from "../queries/__generated__/GetCompanyProfileById";
import {CompanyDetails} from "../interfaces/company-details";
import {GET_SCHOOL_PROFILE_BY_ID} from "../queries/GET_SCHOOL_PROFILE_BY_ID";
import {GetSchoolProfileById} from "../queries/__generated__/GetSchoolProfileById";
import {GET_BOINSTITUTION_PROFILE_BY_ID} from "../queries/GET_BOINSTITUTION_PROFILE_BY_ID";
import {GetBoInstitutionProfileById} from "../queries/__generated__/GetBoInstitutionProfileById";
import {GET_ALL_SCHOOL_SUBJECTS} from "../queries/GET_ALL_SCHOOL_SUBJECTS";
import {SchoolSubject} from "../interfaces/school-subject";
import {SchoolSubjectService} from "./school-subject.service";
import {GetAllSchoolSubjects} from "../queries/__generated__/GetAllSchoolSubjects";
import {GET_ALL_STORIES} from "../queries/GET_ALL_STORIES";
import {GetAllStories} from "../queries/__generated__/GetAllStories";
import {StoryService} from "./story.service";
import {GET_ALL_INFO_SECTION_CATEGORIES} from "../queries/GET_ALL_INFO_SECTION_CATEGORIES";
import {
  GetAllInfoSectionCategories,
  GetAllInfoSectionCategories_infoSectionCategories
} from "../queries/__generated__/GetAllInfoSectionCategories";
import {InfoSectionCategory} from "../interfaces/info-section-category";
import {InfoSectionService} from "./info-section.service";
import {GET_ALL_JOB_PREVIEWS} from "../queries/GET_ALL_JOB_PREVIEWS";
import {GetAllJobPreviews} from "../queries/__generated__/GetAllJobPreviews";
import {JobPreview} from "../interfaces/job-preview";
import {JobService} from "./job.service";
import {GET_JOB_BY_ID} from "../queries/GET_JOB_BY_ID";
import {GET_STORY_BY_ID} from "../queries/GET_STORY_BY_ID";
import {GetStoryById} from "../queries/__generated__/GetStoryById";
import {GET_ALL_INTEREST_FIELDS} from "../queries/GET_ALL_INTEREST_FIELDS";
import {FieldOfInterestPreview} from "../interfaces/field-of-interest-preview";
import {GetAllInterestFields, GetAllInterestFields_interestFields} from "../queries/__generated__/GetAllInterestFields";
import {GET_PROFILES_SEARCH_RESULTS} from "../queries/GET_PROFILES_SEARCH_RESULTS";
import {GetProfilesSearchResults} from "../queries/__generated__/GetProfilesSearchResults";
import {ProvidersArchivePage} from "../interfaces/providers-archive-page";
import {providerTypes} from "../../assets/mock-data/provider-types";
import {JobsArchivePage} from "../interfaces/jobs-archive-page";
import {GET_JOBS_SEARCH_RESULTS} from "../queries/GET_JOBS_SEARCH_RESULTS";
import {GetJobsSearchResults} from "../queries/__generated__/GetJobsSearchResults";
import {GlobalSearchResult} from "../search-filter/global-search-overlay/global-search-result";
import {GET_HOME_CONTENT} from "../queries/GET_HOME_CONTENT";
import {HomeContent} from "../interfaces/home-content";
import {GetHomeContent} from "../queries/__generated__/GetHomeContent";
import {HomeService} from "./home.service";
import {GET_ALL_EVENT_PREVIEWS} from "../queries/GET_ALL_EVENT_PREVIEWS";
import {GetAllEventPreviews, GetAllEventPreviews_events} from "../queries/__generated__/GetAllEventPreviews";
import {GetEventById, GetEventById_event} from "../queries/__generated__/GetEventById";
import {GET_EVENT_BY_ID} from "../queries/GET_EVENT_BY_ID";
import {FaqCategory} from "../interfaces/faq-category";
import {GET_ALL_FAQ_CATEGORIES} from "../queries/GET_ALL_FAQ_CATEGORIES";
import {GetAllFaqCategories} from "../queries/__generated__/GetAllFaqCategories";
import {ProfessionDetails} from "../interfaces/profession-details";
import {CreateBookmark} from "../queries/__generated__/CreateBookmark";
import {CREATE_BOOKMARK} from "../queries/CREATE_BOOKMARK";
import {GetBookmark} from "../queries/__generated__/GetBookmark";
import {GET_BOOKMARK} from "../queries/GET_BOOKMARK";
import {UpdateBookmark} from "../queries/__generated__/UpdateBookmark";
import {UPDATE_BOOKMARK} from "../queries/UPDATE_BOOKMARK";
import {DeleteBookmark} from "../queries/__generated__/DeleteBookmark";
import {DELETE_BOOKMARK} from "../queries/DELETE_BOOKMARK";
import {GetGlobalSearchResults} from "../queries/__generated__/GetGlobalSearchResults";
import {GET_GLOBAL_SEARCH_RESULTS} from "../queries/GET_GLOBAL_SEARCH_RESULTS";
import {GetAllOffers, GetAllOffers_offerList} from "../queries/__generated__/GetAllOffers";
import {GET_ALL_OFFERS} from "../queries/GET_ALL_OFFERS";
import {GET_SCHOOL_CLASS_LOGIN} from "../queries/GET_SCHOOL_CLASS_LOGIN";
import {SET_TROPHY_COUNT} from "../queries/SET_TROPHY_COUNT";
import {GET_SCHOOL_CLASS_GAME_STATE} from "../queries/GET_SCHOOL_CLASS_GAME_STATE";
import {GET_GAME} from "../queries/games/GET_GAME";
import {GET_QUIZ_QUESTION} from "../queries/games/quiz-show/GET_QUIZ_QUESTION";
import {SEND_QUIZ_ANSWER} from "../queries/games/quiz-show/SEND_QUIZ_ANSWER";
import {GET_QUIZ_ANSWER_WRONG} from "../queries/games/quiz-show/GET_QUIZ_ANSWER_WRONG";
import {GET_CLICK_PIC_POINTS} from "../queries/games/picture-discovery/GET_CLICK_PIC_POINTS";
import {GET_CLICK_PIC_QUESTION} from "../queries/games/picture-discovery/GET_CLICK_PIC_QUESTION";
import {SEND_CLICK_THE_PIC_ANSWER} from "../queries/games/picture-discovery/SEND_CLICK_THE_PIC_ANSWER";
import {SET_GAME_END} from "../queries/games/SET_GAME_END";
import {GET_GAME_TROPHY_PROGRESS} from "../queries/GET_GAME_TROPHY_PROGRESS";
import {GET_SCHOOL_CLASS_BY_ID} from "../queries/GET_SCHOOL_CLASS_BY_ID";
import {GET_GAME_CATEGORIES_TEACHER} from "../queries/GET_GAME_CATEGORIES_TEACHER";
import {SET_GAME_CATEGORIES_TEACHER} from "../queries/SET_GAME_CATEGORIES_TEACHER";
import {GET_GAME_CATEGORIES_STUDENT} from "../queries/GET_GAME_CATEGORIES_STUDENT";
import {START_GAME_TIMER} from "../queries/START_GAME_TIMER";
import {GET_GAME_TIMER} from "../queries/GET_GAME_TIMER";
import {MODIFY_GAME_TIMER} from "../queries/MODIFY_GAME_TIMER";
import {GET_GAME_TROPHIES} from "../queries/GET_GAME_TROPHIES";
import {GET_SCHOOL_CLASS_RANKINGS} from "../queries/GET_SCHOOL_CLASS_RANKINGS";
import {SchoolClassData} from "../interfaces/school-class-data";
import {GET_PROVIDER_QUIZ_QUESTION} from "../queries/games/quiz-show/GET_PROVIDER_QUIZ_QUESTION";
import {SCHOOL_CLASS_GAME_HISTORY} from "../queries/SCHOOL_CLASS_GAME_HISTORY";
import {GET_GAME_ACTIVE_USERS} from "../queries/GET_GAME_ACTIVE_USERS";
import {EGame} from "../enums/game";
import {GET_PRIZE_COMPETITION} from "../queries/GET_PRIZE_COMPETITION";
import {TrophyCount} from "../interfaces/trophy-count";
import {GameParserService} from "./game-parser.service";
import {GET_GAME_ROUND_PLAYERS} from "../queries/GET_GAME_ROUND_PLAYERS";
import {GET_SCHOOL_CLASS_POINTS} from "../queries/GET_SCHOOL_CLASS_POINTS";
import {GET_SCHOOL_CLASS_GRADES} from "../queries/GET_SCHOOL_CLASS_GRADES";
import {GET_TEACHING_IDEA_TYPES} from "../queries/GET_TEACHING_IDEA_TYPES";
import {GET_SCHOOL_CLASS_YEARS} from "../queries/GET_SCHOOL_CLASS_YEARS";
import {GET_SCHOOL_CLASSES_BY_SCHOOL} from "../queries/GET_SCHOOL_CLASSES_BY_SCHOOL";
import {GET_PERSON_TITLES} from "../queries/GET_PERSON_TITLES";
import {GET_TEACHING_IDEAS} from "../queries/GET_TEACHING_IDEAS";
import {GET_COMPANY_BENEFITS} from "../queries/GET_COMPANY_BENEFITS";
import {GET_INFORMATION_LINKS} from "../queries/GET_INFORMATION_LINKS";
import {InformationLinksParserService} from "./information-links-parser.service";
import {SchoolClassParserService} from "./school-class-parser.service";
import {GET_VIEWED_JOBS_BY_CLASS_ID} from "../queries/GET_VIEWED_JOBS_BY_CLASS_ID";
import {GET_VIEWED_COMPANIES_BY_CLASS_ID} from "../queries/GET_VIEWED_COMPANIES_BY_CLASS_ID";
import {GET_VIEWED_SCHOOLS_BY_CLASS_ID} from "../queries/GET_VIEWED_SCHOOLS_BY_CLASS_ID";
import {GET_VIEWED_STUDY_PORTRAITS_BY_CLASS_ID} from "../queries/GET_VIEWED_STUDY_PORTRAITS_BY_CLASS_ID";
import {GET_VIEWED_SCHOOL_PORTRAITS_BY_CLASS_ID} from "../queries/GET_VIEWED_SCHOOL_PORTRAITS_BY_CLASS_ID";
import {GET_FAQ_BY_ID} from "../queries/GET_FAQ_BY_ID";
import {GET_FAQ_GEWINNSPIEL} from "../queries/GET_FAQ_GEWINNSPIEL";
import {GET_VIEWED_INTEREST_FIELDS_BY_CLASS_ID} from "../queries/GET_VIEWED_INTEREST_FIELDS_BY_CLASS_ID";
import {GET_VIEWED_REQUIREMENTS_BY_CLASS_ID} from "../queries/GET_VIEWED_REQUIREMENTS_BY_CLASS_ID";
import {GET_EVENTS_BC} from "../queries/GET_EVENTS_BC";
import {GET_PROVIDER_EVENTS_BY_DISTRICT} from "../queries/GET_PROVIDER_EVENTS_BY_DISTRICT";
import {GET_GAME_TIME_LEFT} from "../queries/GET_GAME_TIME_LEFT";
import {CompanyOfferItem} from "../interfaces/company-offer-item";
import {GET_VIEWED_INTEREST_FIELDS_BY_SCHOOL} from "../queries/GET_VIEWED_INTEREST_FIELDS_BY_SCHOOL";
import {GET_SCHOOL_BY_TEACHER} from "../queries/GET_SCHOOL_BY_TEACHER";
import {GET_GAME_TIME_PLAYED} from "../queries/GET_GAME_TIME_PLAYED";
import {GET_GAME_CATEGORIES_PER_GAME} from "../queries/GET_GAME_CATEGORIES_PER_GAME";
import {GET_GAME_TIMERS_SCHOOL} from "../queries/GET_GAME_TIMERS_SCHOOL";
import {GameScoreBoard} from "../interfaces/game_score_board";
import {GET_GAME_SCORE_BOARD} from "../queries/GET_GAME_SCORE_BOARD";
import {GET_COMPANY_SIZES} from "../queries/GET_COMPANY_SIZES";
import {GET_COMPANY_PROFILE_QUIZ_QUESTIONS} from "../queries/GET_COMPANY_PROFILE_QUIZ_QUESTIONS";
import {SEARCH_SCHOOLS} from "../queries/SEARCH_SCHOOLS";
import {GET_JOB_MARKETS_BY_USER} from "../queries/GET_JOB_MARKETS_BY_USER";
import {JobDetails} from "../interfaces/job-details";
import {GET_JOB_BY_ID_INTERNAL} from "../queries/GET_JOB_BY_ID_INTERNAL";
import {GET_GAME_STORY_QUIZ} from "../queries/GET_GAME_STORY_QUIZ";
import {GET_STORY_QUIZ_QUESTION} from "../queries/GET_STORY_QUIZ_QUESTION";
import {SET_STORY_QUIZ_QUESTION_ANSWER} from "../queries/SET_STORY_QUIZ_QUESTION_ANSWER";
import {GET_SCHOOL_CLASS_QUEST} from "../queries/GET_SCHOOL_CLASS_QUEST";
import {GET_SCHOOL_CLASS_QUESTS} from "../queries/GET_SCHOOL_CLASS_QUESTS";
import {GET_GAME_JS_SCHOOL_CLASS} from "../queries/GET_GAME_JR_SCHOOL_CLASS";
import {GET_GAME_JS_SCHOOL_CLASS_ENTRY} from "../queries/GET_GAME_JR_SCHOOL_CLASS_ENTRY";
import {SEND_GAME_JR_ANSWER} from "../queries/SEND_GAME_JR_ANSWER";
import {GET_QUEST_ACTIVE} from "../queries/GET_QUEST_ACTIVE";
import {SEND_COMPANY_PROFILE_QUIZ_QUEST} from "../queries/SEND_COMPANY_PROFILE_QUIZ_QUEST";
import {GET_GAME_TROPHY_HUNT_SCHOOL_CLASS} from "../queries/GET_GAME_TROPHY_HUNT_SCHOOL_CLASS";
import {GET_GAME_TROPHY_HUNT_SCHOOL_CLASS_ENTRY} from "../queries/GET_GAME_TROPHY_HUNT_SCHOOL_CLASS_ENTRY";
import {SEND_GAME_TROPHY_HUNT_ANSWER} from "../queries/SEND_GAME_TROPHY_HUNT_ANSWER";
import {GET_ROOKIE_TIME_SLOTS} from "../queries/GET_ROOKIE_TIME_SLOTS";
import {RookieTimeSlot} from "../interfaces/rookie/rookie-timeslot";
import {GET_ROOKIE_DISTRICT_STATE} from "../queries/GET_ROOKIE_DISTRICT_STATE";
import {GET_ROOKIE_DISTRICT_DATE_RANGE} from "../queries/GET_ROOKIE_DISTRICT_DATE_RANGE";
import {RookieDistrictState} from "../enums/rookie/rookie-district-state";
import {GET_ROOKIE_PROVIDERS} from "../queries/GET_ROOKIE_PROVIDERS";
import {ProviderPreview} from "../interfaces/provider-preview";
import {GET_ROOKIE_JOBS} from "../queries/GET_ROOKIE_JOBS";
import {GET_ROOKIE_OFFER_PREVIEWS_BY_SCHOOL} from "../queries/GET_ROOKIE_OFFER_PREVIEWS_BY_SCHOOL";
import {GET_ROOKIE_DISTRICTS} from "../queries/GET_ROOKIE_DISTRICTS";
import {RookieDistrictServer} from "../interfaces/rookie/rookie-district-server";
import {GET_ROOKIE_OFFER_TIME_SLOT_MAPPING} from "../queries/GET_ROOKIE_OFFER_TIME_SLOT_MAPPING";
import {GET_ROOKIE_SCHOOLS} from "../queries/GET_ROOKIE_SCHOOLS";
import {GET_PROFILES_ROOKIE_SUGGESTIONS} from "../queries/GET_PROFILES_ROOKIE_SUGGESTIONS";
import {GET_PROFILES_ROOKIE_SUGGESTION_DETAILS} from "../queries/GET_PROFILES_ROOKIE_SUGGESTION_DETAILS";
import {ImageService} from "../atoms/image/image.service";
import {RookieProvider} from "../interfaces/rookie/rookie-provider";
import {GET_ROOKIE_SCHOOL_CLASSES} from "../queries/GET_ROOKIE_SCHOOL_CLASSES";
import {GET_ROOKIE_OFFER_TIME_SLOT_MAPPING_BY_CODE} from "../queries/GET_ROOKIE_OFFER_TIME_SLOT_MAPPING_BY_CODE";
import {GET_ROOKIE_PROFESSION_PREVIEWS} from "../queries/GET_ROOKIE_PROFESSION_PREVIEWS";
import {GET_ROOKIE_PROVIDER_REGISTER_TIME} from "../queries/GET_ROOKIE_PROVIDER_REGISTER_TIME";
import {GET_ROOKIE_OFFER_TIME_SLOTS_REMAINING_SLOTS} from "../queries/GET_ROOKIE_OFFER_TIME_SLOTS_REMAINING_SLOTS";
import {RookieDayDistrictServer} from "../interfaces/rookieday/rookieday-district-server";
import {GET_ROOKIE_DAY_DISTRICTS} from "../queries/GET_ROOKIE_DAY_DISTRICTS";
import {GET_ROOKIE_OFFER_PREVIEWS_BY_TIME_SLOTS} from "../queries/GET_ROOKIE_OFFER_PREVIEWS_BY_TIME_SLOTS";
import {GET_ROOKIE_DAY_SCHOOLS} from "../queries/GET_ROOKIE_DAY_SCHOOLS";
import {RookieSchool} from "../interfaces/rookie/rookie-school";
import {GET_ROOKIE_DAY_PROVIDERS} from "../queries/GET_ROOKIE_DAY_PROVIDERS";
import {GET_ROOKIE_DAY_PROVIDER_LOGOS} from "../queries/GET_ROOKIE_DAY_PROVIDER_LOGOS";
import {RookieDayDistrictDate} from "../interfaces/rookieday/rookieday-district-date";
import {GET_ROOKIE_DAY_PROVIDER_REGISTER_TIME} from "../queries/GET_ROOKIE_DAY_PROVIDER_REGISTER_TIME";
import {GET_ROOKIE_DAY_SCHOLAR_REGISTER_TIME} from "../queries/GET_ROOKIE_DAY_SCHOLAR_REGISTER_TIME";
import {RookieDayRegisterTime} from "../interfaces/rookieday/rookieday-register-time";
import {ROOKIEDAY_REGISTER_SCHOLAR} from "../queries/mutations/rookieday/ROOKIEDAY_REGISTER_SCHOLAR";
import {ROOKIEDAY_REGISTER_COMPANY} from "../queries/mutations/rookieday/ROOKIEDAY_REGISTER_COMPANY";
import {ROOKIEDAY_SUBMIT_RECALL_CARD} from "../queries/mutations/rookieday/ROOKIEDAY_SUBMIT_RECALL_CARD";
import {InRookieDayScholarCompany} from "../interfaces/rookie/in-rookieday-scholar-company";
import {GET_ROOKIE_OFFER_BY_ID} from "../queries/GET_ROOKIE_OFFER_BY_ID";
import {GET_ROOKIE_DAY_DISTRICT} from "../queries/GET_ROOKIE_DAY_DISTRICT";
import {RookieSchoolClass} from "../interfaces/rookie/rookie-schoolclass";
import {RookieDaySchool} from "../interfaces/rookieday/rookieday-school";
import {RookieDayDistrict} from "../interfaces/rookieday/rookieday-district";
import {RookieOfferPreview} from "../interfaces/rookie/rookie-offer-preview";
import {RookieOfferTimeSlotMapping} from "../interfaces/rookie/rookie-offer-timeslot-mapping";
import {RookieOffer} from "../interfaces/rookie/rookie-offer";
import {RookieJob} from "../interfaces/rookie/rookie-job";
import {GET_ROOKIE_OFFER_BY_CODE} from "../queries/GET_ROOKIE_OFFER_BY_CODE";
import {RookieDayStudent} from "../interfaces/rookieday/rookieday-student";
import {RookieDayAppointment} from "../interfaces/rookieday/rookieday-appointment";
import {GET_ROOKIE_DAY_STUDENT} from "../queries/GET_ROOKIE_DAY_STUDENT";
import {GET_ROOKIE_DAY_STUDENT_APPOINTMENTS} from "../queries/GET_ROOKIE_DAY_STUDENT_APPOINTMENTS";
import {RookieDayContact} from "../interfaces/rookieday/rookieday-contact";
import {RookieDayContactAppointment} from "../interfaces/rookieday/rookieday-contact-appointment";
import {GET_ROOKIE_DAY_CONTACT} from "../queries/GET_ROOKIE_DAY_CONTACT";
import {GET_ROOKIE_DAY_CONTACT_APPOINTMENTS} from "../queries/GET_ROOKIE_DAY_CONTACT_APPOINTMENTS";
import {ProviderType} from "../interfaces/provider-type";
import {WpPost} from "../interfaces/wp-post";
import {Status} from "../interfaces/backend/status";
import {SchoolClassLogin} from "../interfaces/backend/school-class-login";
import {SchoolClassGameState} from "../interfaces/backend/school-class-game-state";
import {GameEndType, GameSession} from "../interfaces/backend/game-session";
import {GameTrophy} from "../interfaces/backend/game-trophy";
import {SchoolClass} from "../interfaces/backend/school-class";
import {SchoolClassWithStats} from "../interfaces/backend/school-class-with-stats";
import {SchoolClassDataWithStatsMin} from "../interfaces/school-class-data-with-stats-min";
import {GameCategory} from "../interfaces/backend/game-category";
import {SchoolClassRank} from "../interfaces/backend/school-class-rank";
import {GameTimer, GameTimerModifyType} from "../interfaces/backend/game-timer";
import {QuestionOpen} from "../interfaces/backend/question-open";
import {SchoolClassGameHistory} from "../interfaces/backend/school-class-game-history";
import {Championship} from "../interfaces/backend/championship";
import {RoundPlayers} from "../interfaces/backend/round-players";
import {SchoolClassGrade} from "../interfaces/backend/school-class-grade";
import {TeachingIdeaType} from "../interfaces/backend/teaching-idea-type";
import {TeachingIdea} from "../interfaces/backend/teaching-idea";
import {SchoolClassYear} from "../interfaces/backend/school-class-year";
import {PersonTitle} from "../interfaces/backend/person-title";
import {CompanyBenefit} from "../interfaces/backend/company-benefit";
import {InformationLink} from "../interfaces/backend/information-link";
import {UsefullLinkData} from "../interfaces/usefull-link-data";
import {ViewedJob} from "../interfaces/backend/viewed-job";
import {ViewedCompanyProfile} from "../interfaces/backend/viewed-company-profile";
import {ViewedSchoolProfile} from "../interfaces/backend/viewed-school-profile";
import {ViewedStory} from "../interfaces/backend/viewed-story";
import {InterestFieldStats} from "../interfaces/backend/interest-field-stats";
import {JobRequirementStats} from "../interfaces/backend/job-requirement-stats";
import {CommonResult} from "../interfaces/backend/common-result";
import {School} from "../interfaces/backend/school";
import {FaqCategory as BackendFaqCategory} from "../interfaces/backend/faq-category";
import {CompanySize as BackendCompanySize} from "../interfaces/backend/company-size";
import {Event as BackendEvent} from "../interfaces/backend/event";
import {ProviderEventProfile} from "../interfaces/backend/provider-event-profile";
import {JobMarket, JobMarketInternal} from "../interfaces/backend/job-market";
import {GameScoreBoard as BackendGameScoreBoard} from "../interfaces/backend/game-score-board";
import {Quest, QuestUserType} from "../interfaces/backend/quest";
import {SchoolClassQuest} from "../interfaces/backend/school-class-quest";
import {GameJRAnswer, GameJRSchoolClass, GameJRSchoolClassEntry} from "../interfaces/backend/game-jr";
import {GameTrophyHuntAnswer, GameTrophyHuntSchoolClass, GameTrophyHuntSchoolClassEntry} from "../interfaces/backend/game-trophy-hunt";
import {RookieDayDistrict as BackendRookieDayDistrict, RookieDayDistrictListEntry} from "../interfaces/backend/rookieday/rookieday-district";
import {RookieDaySchool as BackendRookieDaySchool} from "../interfaces/backend/rookieday/rookieday-school";
import {RookieDayStudent as BackendRookieDayStudent} from "../interfaces/backend/rookieday/rookieday-student";
import {RookieDayAppointment as BackendRookieDayAppointment} from "../interfaces/backend/rookieday/rookieday-appointment";
import {RookieDayContact as BackendRookieDayContact} from "../interfaces/backend/rookieday/rookieday-contact";
import {RookieDayProvider as BackendRookieDayProvider} from "../interfaces/backend/rookieday/rookieday-provider";
import {RookieDayDistrictState} from "../enums/rookieday/rookieday-district-state";
import {GameTrophyProgress} from "../interfaces/backend/game-trophy-progress";
import {GameTrophyProgressEntry} from "../interfaces/backend/game-trophy-progress-entry";
import {QuizQuestion} from "../interfaces/backend/quiz-question";
import {AnswerResponse} from "../interfaces/backend/answer-response";
import {AnswerWrong} from "../interfaces/backend/answer-wrong";
import {ClickThePicQuestion} from "../interfaces/backend/click-the-pic-question";
import {PictureQuestion} from "../interfaces/picture-question";

;

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(
    private http: HttpClient,
    private apollo: Apollo,
    private jobRequirementsService: JobRequirementsService,
    private providersService: ProvidersService,
    private professionsService: ProfessionsService,
    private schoolSubjectService: SchoolSubjectService,
    private storyService: StoryService,
    private infoSectionService: InfoSectionService,
    private jobService: JobService,
    private homeService: HomeService,
    private gameParserService: GameParserService,
    private informationLinksParserService: InformationLinksParserService,
    private schoolClassParserService: SchoolClassParserService,
    private imageService: ImageService
  ) {
  }

  /*
  getStoryById(storyId: string): Observable<Story> {

    return new Observable(observer => {
      observer.next(dummyStory)
    });

  }
  */

  getProfessionById(id: string) {
    return new Observable<ProfessionDetails>(observer => {
      this.apollo
        .query<GetProfessionById>({
          query: GET_PROFESSION_BY_ID,
          variables: {
            id
          }
        })
        .subscribe(({data, loading}) => {
          if (data.job != null) {
            observer.next(this.professionsService.mapRawProfessionDetailsData(data.job));
          }
          observer.complete();
        }, (error) => {
          console.error(error);
          console.log("Error while requesting profession: " + error.message);
        });
    });
  }

  getAllJobRequirementTypes() {
    return new Observable<RequirementTypesList>(observer => {
      this.apollo
        .query<GetAllJobRequirementTypes>({
          query: GET_ALL_JOB_REQUIREMENT_TYPES
        })
        .subscribe(({data, loading}) => {
          if (data.jobRequirementTypes != null) {
            this.jobRequirementsService.setAllRequirementsFromApi(data.jobRequirementTypes);
            observer.next(this.jobRequirementsService.getAllRequirements());
          }

          observer.complete();
        });
    });
  }

  getAllSchoolSubjects() {
    return new Observable<SchoolSubject[]>(observer => {
      this.apollo
        .query<GetAllSchoolSubjects>({
          query: GET_ALL_SCHOOL_SUBJECTS
        })
        .subscribe(({data, loading}) => {
          let schoolSubjects: SchoolSubject[] = [];
          if (data.schoolSubjects != null) {
            data.schoolSubjects.forEach(rawSchoolSubject => {
              schoolSubjects.push(
                this.schoolSubjectService.mapRawSchoolSubject(rawSchoolSubject)
              )
            });

            this.schoolSubjectService.setAllSubjectsFromAPI(schoolSubjects);
            observer.next(schoolSubjects);
          }
          observer.complete();
        });
    });
  }

  getAllJobPreviews(): Observable<JobPreview[]> {
    return new Observable<JobPreview[]>(observer => {

      let iterations = 0;
      let limit = 500;
      let offset = limit * iterations;
      // let offset = 2000;

      const jobsQuery = this.apollo
        .watchQuery<GetAllJobPreviews>({
          query: GET_ALL_JOB_PREVIEWS,
          variables: {
            offset: offset,
            limit: limit
          }
        });

      // Iterate Over API Pages to get All Jobs
      jobsQuery.valueChanges.subscribe(({data, loading}) => {

        iterations++;

        if (data.jobMarkets && data.jobMarkets?.entries?.length === limit * iterations) {

          // @ts-ignore
          jobsQuery.fetchMore({
            query: GET_ALL_JOB_PREVIEWS,
            // query: ... (you can specify a different query. feedQuery is used by default)
            variables: {
              offset: limit * iterations,
              limit: limit
            },
          });

        } else {
          // Once all Jobs are loaded from API, parse them and return them
          let parsedJobPreviews: JobPreview[] = [];

          data?.jobMarkets?.entries?.forEach((job) => {
            parsedJobPreviews.push(this.jobService.mapRawJobPreview(job));
          });

          observer.next(parsedJobPreviews);

          observer.complete();
        }
      });
    });
  }

  getJobById(id: string): Observable<JobDetails | null> {

    return new Observable<JobDetails | null>(observer => {
      this.apollo
        .query<{jobMarket: JobMarketInternal | null}>({
          query: GET_JOB_BY_ID,
          variables: {
            id
          },
        })
        .subscribe(({data, loading}) => {
          if (data.jobMarket != null) {
            observer.next(this.jobService.mapRawJobDetails(data.jobMarket));
          } else {
            observer.next(null);
          }
          observer.complete();
        });
    });
  }

  getJobByIdPrivate(id: string): Observable<JobDetails> {
    // NO-CACHE POLICY!
    // return this.getJobById(id);
    return new Observable(observer => {
      this.apollo
        .use("internalClient")
        .query<{getJobMarket: JobMarketInternal | null}>({
          query: GET_JOB_BY_ID_INTERNAL,
          variables: {
            id: parseInt(id)
          },
          fetchPolicy: "no-cache"
        })
        .subscribe(({data, loading}) => {
          if (data.getJobMarket != null) {
            observer.next(this.jobService.mapRawJobDetails(data.getJobMarket));
          } else {
            observer.next(undefined);
          }
          observer.complete();
        });
    });
  }

  getRookieProfessionPreviews(): Observable<ProfessionPreview[]> {
    return new Observable<ProfessionPreview[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_PROFESSION_PREVIEWS
        })
        .subscribe(({data, loading}) => {
          if (data.rookieProfessionPreviews != null) {
            observer.next(data.rookieProfessionPreviews);
          }

          observer.complete();
        });
    });
  }

  getAllProfessionPreviews(): Observable<ProfessionPreview[]> {
    return this.http.get<ProfessionPreview[]>(environment.jobsCacheUrl);
  }

  loadAllProfessionPreviews(): Observable<ProfessionPreview[]> {
    return new Observable<ProfessionPreview[]>(observer => {

      // Live Data is skipped for development
      let iterations = 0;
      let limit = 500; // 500
      let offset = limit * iterations;

      const jobsQuery = this.apollo
        .watchQuery<GetProfessions>({
          query: GET_PROFESSIONS,
          variables: {
            offset: offset,
            limit: limit
          }
        });

      // Iterate Over API Pages to get All Jobs
      jobsQuery.valueChanges.subscribe(({data, loading}) => {
        iterations++;
        if (data.jobs && data.jobs.length === limit * iterations) {
          // console.log("Fetching more");
          // @ts-ignore
          jobsQuery.fetchMore({
            query: GET_PROFESSIONS,
            // query: ... (you can specify a different query. feedQuery is used by default)
            variables: {
              offset: limit * iterations,
              limit: limit
            },
          });

        } else {
          // Once all Jobs are loaded from API, parse them and return them
          let parsedProfessionPreviews: ProfessionPreview[] = [];
          data?.jobs?.forEach((job) => {
            parsedProfessionPreviews.push(this.professionsService.mapRawProfessionPreviewData(job));
          });
          // console.log(parsedProfessionPreviews);
          observer.next(parsedProfessionPreviews);
          observer.complete();
        }

      });

    });
  }

  getCompanyProfileById(uuid: string = "", id: number = -1): Observable<CompanyDetails> {
    return new Observable<CompanyDetails>(observer => {
      const variables = id === -1 ? {uuid} : {id};
      this.apollo
        .query<GetCompanyProfileById>({
          query: GET_COMPANY_PROFILE_BY_ID,
          variables
        })
        .subscribe(({data, loading}) => {
          if (data.companyProfile != null) {
            observer.next(this.providersService.mapRawCompanyDetailsData(data.companyProfile));
          }

          observer.complete();
        });
    });
  }

  getSchoolProfileById(uuid: string = "", id: number = -1): Observable<CompanyDetails> {
    return new Observable<CompanyDetails>(observer => {
      const variables = id === -1 ? {uuid} : {id};
      this.apollo
        .query<GetSchoolProfileById>({
          query: GET_SCHOOL_PROFILE_BY_ID,
          variables
        })
        .subscribe(({data, loading}) => {
          if (data.schoolProfile != null) {
            observer.next(this.providersService.mapRawSchoolDetailsData(data.schoolProfile));
          }

          observer.complete();
        });
    });
  }

  getBoInstitutionProfileById(uuid: string = "", id: number = -1): Observable<CompanyDetails> {
    return new Observable<CompanyDetails>(observer => {
      const variables = id === -1 ? {uuid} : {id};
      this.apollo
        .query<GetBoInstitutionProfileById>({
          query: GET_BOINSTITUTION_PROFILE_BY_ID,
          variables
        })
        .subscribe(({data, loading}) => {
          if (data.bopartnerProfile != null) {
            observer.next(this.providersService.mapRawBoInstitutionDetailsData(data.bopartnerProfile));
          }

          observer.complete();
        });
    });
  }

  getAllStories(clientID: string | null = null, useCache = true) {
    return new Observable<Story[]>(observer => {
      this.apollo
        .query<GetAllStories>({
          fetchPolicy: useCache ? "cache-first" : "no-cache",
          query: GET_ALL_STORIES,
          variables: {
            clientID
          }
        })
        .subscribe(({data, loading}) => {
          let stories: Story[] = [];
          if (data.stories != null) {
            data.stories?.entries?.forEach((rawStoryEntry) => {
              stories.push(
                this.storyService.mapRawStoryData(rawStoryEntry)
              )
            });
            observer.next(stories);
          }
          observer.complete();
        });
    });
  }

  getStoryById(id: number) {
    return new Observable<Story>(observer => {
      this.apollo
        .query<GetStoryById>({
          query: GET_STORY_BY_ID,
          variables: {
            id: id
          }
        })
        .subscribe(({data, loading}) => {
          if (data.storyByID != null) {
            observer.next(this.storyService.mapRawStoryData(data.storyByID));
          }
          observer.complete();
        });
    });
  }

  getAllInfoSectionCategories() {
    return new Observable<InfoSectionCategory[]>(observer => {
      this.apollo
        .query<GetAllInfoSectionCategories>({
          query: GET_ALL_INFO_SECTION_CATEGORIES
        })
        .subscribe(({data, loading}) => {
          let infoSectionCategories: InfoSectionCategory[] = [];
          if (data.infoSectionCategories != null) {
            data.infoSectionCategories?.forEach((rawInfoSectionCategories: GetAllInfoSectionCategories_infoSectionCategories) => {
              infoSectionCategories.push(this.infoSectionService.mapRawInfoSectionCategory(rawInfoSectionCategories));
            });
            observer.next(infoSectionCategories);
          }
          observer.complete();
        });
    });
  }

  getAllInterestFields() {
    return new Observable<FieldOfInterestPreview[]>(observer => {
      this.apollo
        .query<GetAllInterestFields>({
          query: GET_ALL_INTEREST_FIELDS
        })
        .subscribe(({data, loading}) => {
          let interestFields: FieldOfInterestPreview[] = [];
          if (data.interestFields != null) {
            data.interestFields?.forEach((rawInterestField: GetAllInterestFields_interestFields) => {
              interestFields.push({
                id: parseInt(rawInterestField.id),
                name: rawInterestField.subHeading,
                tag: rawInterestField.interestName,
                icon: "",
                companiesNumber: rawInterestField.countProviders ?? 0,
                professionsNumber: rawInterestField.countJobs ?? 0
              });
            });
            observer.next(interestFields);
          }
          observer.complete();
        });
    });
  }

  getAllProviderOffers(): Observable<GetAllOffers_offerList> {
    return new Observable<GetAllOffers_offerList>(observer => {

      this.apollo
        .query<GetAllOffers>({
          query: GET_ALL_OFFERS
        })
        .subscribe(({data, loading}) => {

          if (data.offerList) {
            observer.next(data.offerList);
          }

          observer.complete();

        });
    });
  }

  getAllProviderTypes(): Observable<ProviderType[]> {
    return new Observable<ProviderType[]>(observer => {

      observer.next(providerTypes);
      observer.complete();

      return;
    });
  }

  getProfilesSearchResults(searchString: string) {
    return new Observable<ProvidersArchivePage>(observer => {

      let providersArchivePage: ProvidersArchivePage = {
        numResults: 0,
        providerPreviews: []
      }
      // console.log(searchString.toString());

      this.apollo
        .query<GetProfilesSearchResults>({
          query: GET_PROFILES_SEARCH_RESULTS,
          fetchPolicy: "no-cache",
          variables: {
            search: searchString.toString()
          }
        })
        .subscribe(({data, loading}) => {

          providersArchivePage.numResults = data.profiles.numResults ?? 0;

          if (data.profiles.profiles != null) {
            data.profiles?.profiles?.forEach((rawProfile) => {
              providersArchivePage.providerPreviews.push(this.providersService.mapRawProviderPreview(rawProfile));
            });
          }

          observer.next(providersArchivePage);
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next({
            numResults: 0,
            providerPreviews: []
          });
          observer.complete();
        });
    });
  }


  getJobsSearchResults(searchString: string) {
    return new Observable<JobsArchivePage>(observer => {

      let jobArchivePage: JobsArchivePage = {
        numResults: 0,
        jobPreviews: []
      }

      this.apollo
        .query<GetJobsSearchResults>({
          query: GET_JOBS_SEARCH_RESULTS,
          variables: {
            search: searchString.toString()
          }
        })
        .subscribe(({data, loading}) => {
          // console.log(data);
          jobArchivePage.numResults = data.jobMarkets?.numResults ?? 0;

          data?.jobMarkets?.entries?.forEach((job) => {
            jobArchivePage.jobPreviews.push(this.jobService.mapRawJobPreview(job));
          });

          // console.log(searchString);
          // console.log(jobArchivePage);
          observer.next(jobArchivePage);
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next({
            numResults: 0,
            jobPreviews: []
          });
          observer.complete();
        });
    });
  }

  getGlobalSearchResults(searchString: string): Observable<GlobalSearchResult[]> {
    return new Observable<GlobalSearchResult[]>(observer => {
      this.apollo
        .query<GetGlobalSearchResults>({
          query: GET_GLOBAL_SEARCH_RESULTS,
          variables: {
            search: JSON.stringify({searchTerm: searchString})
          }
        })
        .subscribe(({data, loading}) => {

          const results: GlobalSearchResult[] = [];
          if (data.globalSearch?.jobs?.length) {
            data.globalSearch.jobs.forEach((el) => {
              results.push(this.professionsService.mapGlobalSearchResult(el));
            })
          }

          if (data.globalSearch?.jobMarkets?.length) {
            data.globalSearch.jobMarkets.forEach((el) => {
              results.push(this.jobService.mapGlobalSearchResult(el));
            })
          }

          if (data.globalSearch?.profiles?.length) {
            data.globalSearch.profiles.forEach((el) => {
              results.push(this.providersService.mapGlobalSearchResult(el));
            })
          }

          if (data.globalSearch?.stories?.length) {
            data.globalSearch.stories.forEach((el) => {
              results.push(this.storyService.mapGlobalSearchResult(el));
            })
          }

          observer.next(results);
          observer.complete();
        });
    });
  }

  getRecentBlogPosts(): Observable<WpPost[]> {
    return this.http.get<WpPost[]>("https://blog.berufsreise.at/wp-json/wp/v2/posts?_embed")
  }


  getHomeContent() {
    return new Observable<HomeContent>(observer => {
      this.apollo
        .query<GetHomeContent>({
          query: GET_HOME_CONTENT
        })
        .subscribe(({data, loading}) => {
          if (data.homeContent != null) {
            observer.next(this.homeService.mapRawHomeContent(data.homeContent));
          }
          observer.complete();
        });
    });
  }

  getAllEventPreviews(): Observable<GetAllEventPreviews_events[]> {
    return new Observable<GetAllEventPreviews_events[]>(observer => {
      this.apollo
        .query<GetAllEventPreviews>({
          query: GET_ALL_EVENT_PREVIEWS
        })
        .subscribe(({data, loading}) => {
          observer.next(data.events ?? []);
          observer.complete();
        });
    });
  }

  getEventById(id: string): Observable<GetEventById_event | null> {
    return new Observable<GetEventById_event | null>(observer => {
      this.apollo
        .query<GetEventById>({
          query: GET_EVENT_BY_ID,
          variables: {
            id: id
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.event ?? null);
          observer.complete();
        });
    });
  }

  getAllFaqCategories() {
    return new Observable<FaqCategory[]>(observer => {
      this.apollo
        .query<GetAllFaqCategories>({
          query: GET_ALL_FAQ_CATEGORIES
        })
        .subscribe(({data, loading}) => {
          let faqCategories: FaqCategory[] = [];
          if (data.faqCategories != null) {
            data.faqCategories?.forEach((rawFaqCategory) => {
              faqCategories.push({
                id: encodeURIComponent(rawFaqCategory.categoryName.replaceAll(" ", "-")),
                categoryName: rawFaqCategory.categoryName ?? "",
                // @ts-ignore
                subcategories: rawFaqCategory.subcategories ?? []
              });
            });
            observer.next(faqCategories);
          }
          observer.complete();
        });
    });
  }

  createFavorites() {
    return new Observable<string>(observer => {
      this.apollo
        .query<CreateBookmark>({
          query: CREATE_BOOKMARK,
          fetchPolicy: "no-cache"
        })
        .subscribe(({data, loading}) => {
          if (data.bookmarkCreate) {
            observer.next(data.bookmarkCreate.accessToken)
          } else {
            observer.next("");
          }
          observer.complete();
        })
    })
  }

  getFavorites(code: string) {
    return new Observable<string>(observer => {
      this.apollo
        .query<GetBookmark>({
          query: GET_BOOKMARK,
          variables: {
            code: code.toUpperCase(),
            fetchPolicy: "no-cache"
          }
        })
        .subscribe(({data, loading}) => {
          if (data.bookmarkGet) {
            observer.next(data.bookmarkGet.storedValue ?? "")
          } else {
            observer.next("");
          }
          observer.complete();
        })
    })
  }

  updateFavorites(code: string, value: string) {
    return new Observable<boolean>(observer => {
      this.apollo
        .query<UpdateBookmark>({
          query: UPDATE_BOOKMARK,
          variables: {
            code: code.toUpperCase(),
            value,
            fetchPolicy: "no-cache"
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(true);
          observer.complete();
        })
    })
  }

  deleteFavorites(code: string) {
    return new Observable<string>(observer => {
      this.apollo
        .query<DeleteBookmark>({
          query: DELETE_BOOKMARK,
          variables: {
            code: code.toUpperCase(),
            fetchPolicy: "no-cache"
          }
        })
        .subscribe(({data, loading}) => {
          if (data.bookmarkDelete) {
            observer.next(data.bookmarkDelete ?? "");
          } else {
            observer.next("");
          }
          observer.complete();
        })
    })
  }


  loginSchoolClass(schoolClassLogin: string): Observable<SchoolClassLogin | false> {
    return new Observable<SchoolClassLogin | false>(observer => {
      this.apollo
        .query<{schoolClassLogin: SchoolClassLogin | null}>({
          query: GET_SCHOOL_CLASS_LOGIN,
          fetchPolicy: "no-cache",
          variables: {
            code: schoolClassLogin.toUpperCase()
          }
        })
        .subscribe(({data, loading}) => {
          // console.log(data);
          if (data) {
            observer.next(data.schoolClassLogin ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  setTrophyCount(visitInfo: TrophyCount): Observable<Status | false> {
    return new Observable<Status | false>(observer => {
      this.apollo
        .query<{trophyCount: Status}>({
          query: SET_TROPHY_COUNT,
          variables: {
            clientId: visitInfo.clientId,
            classCode: visitInfo.classCode,
            itemId: visitInfo.itemId,
            itemType: visitInfo.itemType
          }
        })
        .subscribe(({data, loading}) => {
          if (data.trophyCount.type === "OK") {
            observer.next(data.trophyCount ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  getSchoolClassGameState(classCode: String): Observable<SchoolClassGameState | false> {
    return new Observable<SchoolClassGameState | false>(observer => {
      this.apollo
        .query<{schoolClassGameState: SchoolClassGameState | null}>({
          query: GET_SCHOOL_CLASS_GAME_STATE,
          variables: {
            classCode
          }
        })
        .subscribe(({data, loading}) => {
          if (data.schoolClassGameState?.status.type === "OK") {
            observer.next(data.schoolClassGameState ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  getGame(gameType: String, clientId: String, categoryIds: number[]): Observable<GameSession | false> {
    return new Observable<GameSession | false>(observer => {
      this.apollo
        .query<{getGame: GameSession}>({
          query: GET_GAME,
          fetchPolicy: "no-cache",
          variables: {
            gameType,
            clientId,
            categoryIds
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getGame.status.type === "OK") {
            observer.next(data.getGame ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  getQuizShowQuestion(gameId: string, round: number): Observable<QuizQuestion | false> {
    return new Observable<QuizQuestion | false>(observer => {
      this.apollo
        .query<{getQuizQuestion: QuizQuestion}>({
          query: GET_QUIZ_QUESTION,
          fetchPolicy: "no-cache",
          variables: {
            gameId: parseInt(gameId),
            round
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getQuizQuestion.status?.type === "OK") {
            observer.next(data.getQuizQuestion ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  sendQuizAnswer(gameId: string, questionId: number, answerId: number): Observable<AnswerResponse | false> {
    return new Observable<AnswerResponse | false>(observer => {
      this.apollo
        .query<{sendQuizAnswer: AnswerResponse}>({
          query: SEND_QUIZ_ANSWER,
          variables: {
            gameId: parseInt(gameId),
            questionId,
            answerId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.sendQuizAnswer) {
            observer.next(data.sendQuizAnswer ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }


  getQuizAnswerWrong(gameId: string, questionId: number): Observable<AnswerWrong | false> {
    return new Observable<AnswerWrong | false>(observer => {
      this.apollo
        .query<{getQuizAnswerWrong: AnswerWrong}>({
          query: GET_QUIZ_ANSWER_WRONG,
          variables: {
            gameId: parseInt(gameId),
            questionId,
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getQuizAnswerWrong) {
            observer.next(data.getQuizAnswerWrong ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  getClickPicPoints(gameId: string): Observable<number[] | false> {
    return new Observable<number[] | false>(observer => {
      this.apollo
        .query<{getClickThePicPointSteps: number[] | null}>({
          query: GET_CLICK_PIC_POINTS,
          fetchPolicy: "no-cache",
          variables: {
            gameId: parseInt(gameId)
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getClickThePicPointSteps ?? false);
          observer.complete();
        })
    })
  }

  getClickPicQuestion(gameId: string, round: number): Observable<PictureQuestion | false> {
    return new Observable<PictureQuestion | false>(observer => {
      this.apollo
        .query<{getClickThePicQuestion: ClickThePicQuestion}>({
          query: GET_CLICK_PIC_QUESTION,
          fetchPolicy: "no-cache",
          variables: {
            gameId: parseInt(gameId),
            round
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getClickThePicQuestion.status?.type === "OK") {
            observer.next(this.gameParserService.mapRawClickThePicQuestion(data.getClickThePicQuestion, gameId));
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }


  sendClickThePicAnswer(gameId: string, questionId: number, answerId: number, points: number): Observable<AnswerResponse | false> {
    return new Observable<AnswerResponse | false>(observer => {
      this.apollo
        .query<{sendClickThePicAnswer: AnswerResponse}>({
          query: SEND_CLICK_THE_PIC_ANSWER,
          variables: {
            gameId: parseInt(gameId),
            questionId,
            answerId,
            points
          }
        })
        .subscribe(({data, loading}) => {
          if (data.sendClickThePicAnswer) {
            observer.next(data.sendClickThePicAnswer ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }


  setEndGame(gameId: string, gameEnd: GameEndType, points: number): Observable<Status | false> {
    return new Observable<Status | false>(observer => {
      this.apollo
        .query<{setGameEnd: Status}>({
          query: SET_GAME_END,
          variables: {
            gameId: parseInt(gameId),
            gameEnd,
            points
          }
        })
        .subscribe(({data, loading}) => {
          if (data.setGameEnd) {
            observer.next(data.setGameEnd ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  getGameTrophyProgress(schoolClassId: number): Observable<GameTrophyProgressEntry[] | false> {
    return new Observable<GameTrophyProgressEntry[] | false>(observer => {
      this.apollo
        .query<{getGameTrophyProgress: GameTrophyProgress}>({
          query: GET_GAME_TROPHY_PROGRESS,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getGameTrophyProgress && data.getGameTrophyProgress.entries) {
            observer.next(data.getGameTrophyProgress.entries ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }

  getGameTrophies(): Observable<GameTrophy[]> {
    return new Observable<GameTrophy[]>(observer => {
      this.apollo
        .query<{getGameTrophies: (GameTrophy | null)[] | null}>({
          query: GET_GAME_TROPHIES,
          fetchPolicy: "no-cache"
        })
        .subscribe(({data, loading}) => {
          // console.log(data);
          if (data.getGameTrophies) {
            observer.next(data.getGameTrophies.filter((trophy): trophy is GameTrophy => trophy !== null));
          } else {
            observer.next([]);
          }
          observer.complete();
        })
    })
  }

  getSchoolClassById(schoolClassId: number): Observable<SchoolClassData | undefined> {
    return new Observable<SchoolClassData | undefined>(observer => {
      if (!schoolClassId) {
        observer.next(undefined);
        observer.complete();
      } else {
        this.apollo
          .use("internalClient")
          .query<{getSchoolClassByID: SchoolClass | null}>({
            query: GET_SCHOOL_CLASS_BY_ID,
            fetchPolicy: "no-cache",
            variables: {
              schoolClassId
            }
          })
          .subscribe(({data, loading}) => {
            if (data.getSchoolClassByID) {
              // console.log("data.getSchoolClassByID", data.getSchoolClassByID);
              observer.next(this.schoolClassParserService.mapRawSchoolClass(data.getSchoolClassByID));
            } else {
              observer.next(undefined);
            }
            observer.complete();
          })
      }

    })
  }


  setGameCategoriesTeacher(schoolClassId: number, categoryIds: number[]): Observable<Status | false> {
    return new Observable<Status | false>(observer => {
      this.apollo
        .use("internalClient")
        .query<{setGameCategoriesTeacher: Status}>({
          query: SET_GAME_CATEGORIES_TEACHER,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId,
            categoryIds
          }
        })
        .subscribe(({data, loading}) => {
          if (data.setGameCategoriesTeacher) {
            observer.next(data.setGameCategoriesTeacher ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        })
    })
  }


  getSchoolClassesBySchool(): Observable<SchoolClassDataWithStatsMin[]> {
    return new Observable<SchoolClassDataWithStatsMin[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getSchoolClassesBySchool: SchoolClassWithStats[] | null}>({
          query: GET_SCHOOL_CLASSES_BY_SCHOOL
        })
        .subscribe(({data, loading}) => {
          if (data.getSchoolClassesBySchool) {
            observer.next(data.getSchoolClassesBySchool.map(schoolClass => this.schoolClassParserService.mapRawSchoolClassWithStats(schoolClass)));
          } else {
            observer.next([]);
          }

          observer.complete();
        });
    });
  }

  getGameCategoriesTeacher(schoolClassId: number): Observable<GameCategory[] | false> {
    return new Observable<GameCategory[] | false>(observer => {
      this.apollo
        .query<{getGameCategoriesTeacher: GameCategory[] | null}>({
          query: GET_GAME_CATEGORIES_TEACHER,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId
          }
        })
        .subscribe(({data, loading}) => {

          // console.log(data);

          if (data.getGameCategoriesTeacher) {
            observer.next(data.getGameCategoriesTeacher ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });

  }

  getGameCategoriesStudent(clientId: string, gameType: string): Observable<GameCategory[] | false> {
    return new Observable<GameCategory[] | false>(observer => {
      this.apollo
        .query<{getGameCategoriesStudent: GameCategory[] | null}>({
          query: GET_GAME_CATEGORIES_STUDENT,
          fetchPolicy: "no-cache",
          variables: {
            clientId,
            gameType
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getGameCategoriesStudent) {
            observer.next(data.getGameCategoriesStudent ?? false);
          } else {
            observer.next(false);
          }
          observer.complete();
        });
    });
  }

  getSchoolClassRankings(): Observable<SchoolClassRank[] | false> {
    return new Observable<SchoolClassRank[] | false>(observer => {
      this.apollo
        .query<{schoolClassRankings: SchoolClassRank[] | null}>({
          query: GET_SCHOOL_CLASS_RANKINGS,
          fetchPolicy: "no-cache"
        })
        .subscribe(({data, loading}) => {
          if (data.schoolClassRankings) {
            observer.next(data.schoolClassRankings ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });

  }


  startGameTimer(schoolClassId: number, duration: number): Observable<GameTimer | false> {
    return new Observable<GameTimer | false>(observer => {
      this.apollo
        .use("internalClient")
        .query<{startGameTimer: GameTimer | null}>({
          query: START_GAME_TIMER,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId,
            duration
          }
        })
        .subscribe(({data, loading}) => {
          if (data.startGameTimer) {
            observer.next(data.startGameTimer ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });

  }

  modifyGameTimer(timerId: number, duration: number, modifyType: GameTimerModifyType): Observable<GameTimer | false> {
    return new Observable<GameTimer | false>(observer => {
      this.apollo
        .use("internalClient")
        .query<{modifyGameTimer: GameTimer | null}>({
          query: MODIFY_GAME_TIMER,
          fetchPolicy: "no-cache",
          variables: {
            timerId,
            duration,
            modifyType
          }
        })
        .subscribe(({data, loading}) => {

          // console.log(data);

          if (data.modifyGameTimer) {
            observer.next(data.modifyGameTimer ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });

  }

  getGameTimer(schoolClassId: number): Observable<GameTimer | false> {
    return new Observable<GameTimer | false>(observer => {
      this.apollo
        .query<{getGameTimer: GameTimer | null}>({
          query: GET_GAME_TIMER,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getGameTimer?.status.type === "OK") {
            observer.next(data.getGameTimer ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });

  }

  getProviderQuizQuestion(companyProfileId: number, providerType: number): Observable<QuestionOpen[] | false> {
    return new Observable<QuestionOpen[] | false>(observer => {
      this.apollo
        .query<{getQuizQuestionsProvider: QuestionOpen[] | null}>({
          query: GET_PROVIDER_QUIZ_QUESTION,
          fetchPolicy: "no-cache",
          variables: {
            companyProfileId,
            providerType
          }
        })
        .subscribe(({data, loading}) => {

          // console.log(data);

          if (data.getQuizQuestionsProvider) {
            observer.next(data.getQuizQuestionsProvider ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });

  }

  getSchoolClassGameHistory(classEntryCode: string): Observable<SchoolClassGameHistory[] | false> {
    return new Observable<SchoolClassGameHistory[] | false>(observer => {
      this.apollo
        .query<{schoolClassGameHistory: SchoolClassGameHistory[] | null}>({
          query: SCHOOL_CLASS_GAME_HISTORY,
          fetchPolicy: "no-cache",
          variables: {
            classCode: classEntryCode
          }
        })
        .subscribe(({data, loading}) => {
          if (data.schoolClassGameHistory) { // createdAt template "2024-07-31 11:47:37"
            observer.next(data.schoolClassGameHistory ?? false);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });
  }

  getSchoolClassPoints(classEntryCode: string): Observable<number> {
    return new Observable<number>(observer => {
      this.apollo
        .query<{schoolClassPoints: number | null}>({
          query: GET_SCHOOL_CLASS_POINTS,
          fetchPolicy: "no-cache",
          variables: {
            classCode: classEntryCode
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.schoolClassPoints ?? 0);
          observer.complete();
        });
    });
  }

  getSchoolClassTimePlayed(classEntryCode: string): Observable<number> {
    return new Observable<number>(observer => {
      this.apollo
        .query<{schoolClassTimePlayed: number | null}>({
          query: GET_GAME_TIME_PLAYED,
          fetchPolicy: "no-cache",
          variables: {
            classCode: classEntryCode
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.schoolClassTimePlayed ?? 0);
          observer.complete();
        });
    });
  }

  getGameActiveUsers(game: EGame): Observable<number> {
    return new Observable<number>(observer => {
      this.apollo
        .query<{getGameActiveUsers: number}>({
          query: GET_GAME_ACTIVE_USERS,
          fetchPolicy: "no-cache",
          variables: {
            game
          }
        }).pipe()
        .subscribe(({data, loading}) => {
          if ('getGameActiveUsers' in data) {
            observer.next(data.getGameActiveUsers ?? 0);
          } else {
            console.warn("getGameActiveUsers doesn't exist (on game online update)");
            observer.next(0);
          }

          observer.complete();
        });
    });
  }

  getPrizeCompetition(): Observable<Championship | null> {
    return new Observable<Championship | null>(observer => {
      this.apollo
        .query<{getChampionship: Championship | null}>({
          query: GET_PRIZE_COMPETITION,
          fetchPolicy: "no-cache",
          variables: {}
        }).pipe()
        .subscribe(({data, loading}) => {
          if ('getChampionship' in data) {
            observer.next(data.getChampionship ?? null);
          } else {
            console.warn("getChampionship doesn't exist");
            observer.next(null);
          }

          observer.complete();
        });
    });
  }

  getGameRoundPlayers(gameId: number): Observable<RoundPlayers | null> {
    return new Observable<RoundPlayers | null>(observer => {
      this.apollo
        .query<{getGameRoundPlayers: RoundPlayers}>({
          query: GET_GAME_ROUND_PLAYERS,
          fetchPolicy: "no-cache",
          variables: {
            gameId
          }
        }).pipe()
        .subscribe(({data, loading}) => {
          observer.next(data.getGameRoundPlayers ?? null);
          observer.complete();
        });
    });
  }

  getSchoolClassGrades(): Observable<SchoolClassGrade[] | null> {
    return new Observable<SchoolClassGrade[] | null>(observer => {
      this.apollo
        .query<{schoolClassGrades: SchoolClassGrade[] | null}>({
          query: GET_SCHOOL_CLASS_GRADES,
          fetchPolicy: "no-cache"
        }).pipe()
        .subscribe(({data, loading}) => {
          observer.next(data.schoolClassGrades ?? null);
          observer.complete();
        });
    });
  }

  getTeachingIdeaTypes(): Observable<TeachingIdeaType[]> {
    return new Observable<TeachingIdeaType[]>(observer => {
      this.apollo
        .query<{teachingIdeaTypes: TeachingIdeaType[] | null}>({
          query: GET_TEACHING_IDEA_TYPES,
          fetchPolicy: "no-cache"
        }).pipe()
        .subscribe(({data, loading}) => {
          observer.next(data.teachingIdeaTypes ?? []);
          observer.complete();
        });
    });
  }

  getSchoolClassYears(): Observable<SchoolClassYear[]> {
    return new Observable<SchoolClassYear[]>(observer => {
      this.apollo
        .query<{schoolClassYears: SchoolClassYear[] | null}>({
          query: GET_SCHOOL_CLASS_YEARS,
          fetchPolicy: "no-cache"
        }).pipe()
        .subscribe(({data, loading}) => {
          observer.next(data.schoolClassYears ?? []);
          observer.complete();
        });
    });
  }

  getPersonTitles(): Observable<PersonTitle[]> {
    return new Observable<PersonTitle[]>(observer => {
      this.apollo
        .query<{titles: (PersonTitle | null)[] | null}>({
          query: GET_PERSON_TITLES,
          fetchPolicy: "no-cache"
        }).pipe()
        .subscribe(({data, loading}) => {
          observer.next((data.titles ?? []).filter((title): title is PersonTitle => title !== null));
          observer.complete();
        });
    });
  }

  getTeachingIdeas(classId: number): Observable<TeachingIdea[]> {
    return new Observable<TeachingIdea[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getTeachingIdeas: TeachingIdea[] | null}>({
          query: GET_TEACHING_IDEAS,
          fetchPolicy: "no-cache",
          variables: {
            classId
          }
        }).pipe()
        .subscribe(({data, loading}) => {
          observer.next(data.getTeachingIdeas ?? []);
          observer.complete();
        });
    });
  }

  getCompanyBenefits(): Observable<CompanyBenefit[]> {
    return new Observable<CompanyBenefit[]>(observer => {
      this.apollo
        .query<{getCompanyBenefits: CompanyBenefit[] | null}>({
          query: GET_COMPANY_BENEFITS
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getCompanyBenefits ?? []);
          observer.complete();
        });
    });
  }

  getInformationLinks(typeId: number): Observable<UsefullLinkData[]> {
    return new Observable<UsefullLinkData[]>(observer => {
      this.apollo
        .query<{informationLinks: InformationLink[] | null}>({
          query: GET_INFORMATION_LINKS,
          variables: {
            typeId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(this.informationLinksParserService.parseRawInformationLinks(data.informationLinks ?? []));
          observer.complete();
        });
    });
  }

  getViewedJobsByClassId(classId: number): Observable<ViewedJob[]> {
    return new Observable<ViewedJob[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedJobs: ViewedJob[] | null}>({
          query: GET_VIEWED_JOBS_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedJobs ?? []);
          observer.complete();
        });
    });
  }

  getViewedCompaniesByClassId(classId: number): Observable<ViewedCompanyProfile[]> {
    return new Observable<ViewedCompanyProfile[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedCompanyProfiles: ViewedCompanyProfile[] | null}>({
          query: GET_VIEWED_COMPANIES_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedCompanyProfiles ?? []);
          observer.complete();
        });
    });
  }

  getViewedSchoolsByClassId(classId: number): Observable<ViewedSchoolProfile[]> {
    return new Observable<ViewedSchoolProfile[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedSchoolProfiles: ViewedSchoolProfile[] | null}>({
          query: GET_VIEWED_SCHOOLS_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedSchoolProfiles ?? []);
          observer.complete();
        });
    });
  }

  getViewedStudyPortraits(classId: number): Observable<ViewedStory[]> {
    return new Observable<ViewedStory[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedJobPortaits: ViewedStory[] | null}>({
          query: GET_VIEWED_STUDY_PORTRAITS_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedJobPortaits ?? []);
          observer.complete();
        });
    });
  }

  getViewedSchoolPortraits(classId: number): Observable<ViewedStory[]> {
    return new Observable<ViewedStory[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedSchoolPortaits: ViewedStory[] | null}>({
          query: GET_VIEWED_SCHOOL_PORTRAITS_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedSchoolPortaits ?? []);
          observer.complete();
        });
    });
  }


  getFaqsGewinnspiel(): Observable<BackendFaqCategory | null> {
    return new Observable<BackendFaqCategory | null>(observer => {
      this.apollo
        .query<{faqGewinnspiel: BackendFaqCategory | null}>({
          query: GET_FAQ_GEWINNSPIEL
        })
        .subscribe(({data, loading}) => {
          observer.next(data.faqGewinnspiel);
          observer.complete();
        });
    });
  }

  getBoPlusFaqs(categoryId: number): Observable<BackendFaqCategory | null> {
    return new Observable<BackendFaqCategory | null>(observer => {
      this.apollo
        .query<{faqCategoryByID: BackendFaqCategory | null}>({
          query: GET_FAQ_BY_ID,
          variables: {id: categoryId}
        })
        .subscribe(({data, loading}) => {
          observer.next(data.faqCategoryByID);
          observer.complete();
        });
    });
  }

  getViewedInterestFieldsByClassId(classId: number): Observable<InterestFieldStats[]> {
    return new Observable<InterestFieldStats[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedInterestFields: InterestFieldStats[] | null}>({
          query: GET_VIEWED_INTEREST_FIELDS_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedInterestFields ?? []);
          observer.complete();
        });
    });
  }

  getViewedInterestFieldsBySchool(): Observable<InterestFieldStats[]> {
    return new Observable<InterestFieldStats[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedInterestFieldsBySchool: InterestFieldStats[] | null}>({
          query: GET_VIEWED_INTEREST_FIELDS_BY_SCHOOL
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedInterestFieldsBySchool ?? []);
          observer.complete();
        });
    });
  }

  getViewedRequirementsByClassId(classId: number): Observable<JobRequirementStats[]> {
    return new Observable<JobRequirementStats[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getViewedRequirements: JobRequirementStats[] | null}>({
          query: GET_VIEWED_REQUIREMENTS_BY_CLASS_ID,
          variables: {
            classId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getViewedRequirements ?? []);
          observer.complete();
        });
    });
  }

  getEventsBc(): Observable<BackendEvent[]> {
    return new Observable<BackendEvent[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getEventsBcByDistrict: BackendEvent[] | null}>({
          query: GET_EVENTS_BC
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getEventsBcByDistrict ?? []);
          observer.complete();
        });
    });
  }

  getProviderEventsByDistrict(): Observable<CompanyOfferItem[]> {
    return new Observable<CompanyOfferItem[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getProviderEventsByDistrict: ProviderEventProfile[] | null}>({
          query: GET_PROVIDER_EVENTS_BY_DISTRICT
        })
        .subscribe(({data, loading}) => {
          observer.next(this.providersService.parseProviderOffers(data.getProviderEventsByDistrict) ?? []);
          observer.complete();
        });
    });
  }

  getGameTimeLeft(schoolClassId: number): Observable<number> {
    return new Observable<number>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getGameTimeLeft: CommonResult}>({
          query: GET_GAME_TIME_LEFT,
          variables: {
            schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getGameTimeLeft?.intValue ?? 0);
          observer.complete();
        });
    });
  }

  getSchoolByTeacher(): Observable<School | undefined> {
    return new Observable<School | undefined>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getSchoolByTeacher: School | null}>({
          query: GET_SCHOOL_BY_TEACHER,
          fetchPolicy: "no-cache",
          variables: {}
        })
        .subscribe(({data, loading}) => {
          if (data.getSchoolByTeacher) {
            observer.next(data.getSchoolByTeacher);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })

    })
  }

  getCompanySizes(): Observable<BackendCompanySize[]> {
    return new Observable<BackendCompanySize[]>(observer => {
      this.apollo
        .query<{getCompanySizes: BackendCompanySize[] | null}>({
          query: GET_COMPANY_SIZES
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getCompanySizes ?? []);
          observer.complete();
        });
    });
  }

  getSchoolsSuggestion(searchText: string): Observable<School[]> {
    return new Observable<School[]>(observer => {
      this.apollo
        .query<{searchSchools: School[] | null}>({
          query: SEARCH_SCHOOLS,
          variables: {
            searchText
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.searchSchools ?? []);
          observer.complete();
        });
    });
  }

  getJobsByUser(): Observable<JobDetails[]> {
    return new Observable<JobDetails[]>(observer => {
      this.apollo
        .use("internalClient")
        .query<{getJobMarketsByUser: JobMarket[] | null}>({
          query: GET_JOB_MARKETS_BY_USER,
          fetchPolicy: "no-cache",
          variables: {}
        })
        .subscribe(({data, loading}) => {
          observer.next((data.getJobMarketsByUser ?? []).map((el) => this.jobService.mapRawJobDetails(el)));
          observer.complete();
        })
    })
  }

  getGameScoreBoard(gameId: number): Observable<GameScoreBoard> {
    return new Observable<GameScoreBoard>(observer => {
      this.apollo
        .query<{getGameScoreBoard: BackendGameScoreBoard}>({
          query: GET_GAME_SCORE_BOARD,
          fetchPolicy: "no-cache",
          variables: {
            gameId: gameId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next({
            multiplier: data.getGameScoreBoard.multiplier,
            entries: data.getGameScoreBoard.entries ?? []
          });
          observer.complete();
        })
    })
  }

  getGameStoryQuiz(clientId: string, storyId: number): Observable<Pick<GameSession, "id" | "status">> {
    return new Observable<Pick<GameSession, "id" | "status">>(observer => {
      this.apollo
        .query<{getStoryGame: Pick<GameSession, "id" | "status">}>({
          query: GET_GAME_STORY_QUIZ,
          fetchPolicy: "no-cache",
          variables: {
            clientId,
            storyId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getStoryGame);
          observer.complete();
        })
    })
  }

  getStoryQuizQuestion(gameId: number, round: number): Observable<QuizQuestion> {
    return new Observable<QuizQuestion>(observer => {
      this.apollo
        .query<{getStoryQuizQuestion: QuizQuestion}>({
          query: GET_STORY_QUIZ_QUESTION,
          fetchPolicy: "no-cache",
          variables: {
            gameId,
            round
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getStoryQuizQuestion);
          observer.complete();
        })
    })
  }

  setStoryQuizQuestionAnswer(gameId: number, questionId: number, answerId: number): Observable<AnswerResponse> {
    return new Observable<AnswerResponse>(observer => {
      this.apollo
        .query<{sendStoryQuizAnswer: AnswerResponse}>({
          query: SET_STORY_QUIZ_QUESTION_ANSWER,
          fetchPolicy: "no-cache",
          variables: {
            gameId,
            questionId,
            answerId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.sendStoryQuizAnswer);
          observer.complete();
        })
    })
  }

  // getSchoolClassQuests(classEntryCode: string) {
  //   return new Observable<any>(observer => {
  //     this.apollo
  //       .query<any>({
  //         query: GET_SCHOOL_CLASS_QUESTS,
  //         fetchPolicy: "no-cache",
  //         variables: {
  //           classCode: classEntryCode
  //         }
  //       })
  //       .subscribe(({data, loading}) => {
  //         if(data.getSchoolClassQuests) {
  //           observer.next(data.getSchoolClassQuests ?? undefined);
  //         } else {
  //           observer.next(false);
  //         }
  //
  //         observer.complete();
  //       });
  //   });
  // }

  getMonthQuestData(): Observable<Quest | false> {

    return new Observable<Quest | false>(observer => {
      this.apollo
        .query<{getQuestActive: Quest | null}>({
          query: GET_QUEST_ACTIVE,
          fetchPolicy: "no-cache"
        })
        .subscribe(({data, loading}) => {
          if (data.getQuestActive) {
            observer.next(data.getQuestActive);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });
  }

  getSchoolClassQuest(classEntryCode: string, userType: QuestUserType): Observable<SchoolClassQuest | false> {
    return new Observable<SchoolClassQuest | false>(observer => {
      this.apollo
        .query<{getSchoolClassQuest: SchoolClassQuest | null}>({
          query: GET_SCHOOL_CLASS_QUEST,
          fetchPolicy: "no-cache",
          variables: {
            classCode: classEntryCode,
            userType
          }
        })
        .subscribe(({data, loading}) => {
          if (data.getSchoolClassQuest) {
            observer.next(data.getSchoolClassQuest);
          } else {
            observer.next(false);
          }

          observer.complete();
        });
    });
  }

  getGameJrSchoolClass(schoolClassId: number): Observable<GameJRSchoolClass> {
    return new Observable<GameJRSchoolClass>(observer => {
      this.apollo
        .query<{getGameJRSchoolClass: GameJRSchoolClass}>({
          query: GET_GAME_JS_SCHOOL_CLASS,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId: schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getGameJRSchoolClass);
          observer.complete();
        })
    })
  }

  getGameJrSchoolClassEntry(schoolClassId: number): Observable<GameJRSchoolClassEntry> {
    return new Observable<GameJRSchoolClassEntry>(observer => {
      this.apollo
        .query<{getGameJRSchoolClassEntry: GameJRSchoolClassEntry}>({
          query: GET_GAME_JS_SCHOOL_CLASS_ENTRY,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId: schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getGameJRSchoolClassEntry);
          observer.complete();
        })
    })
  }

  sendGameJrAnswer(entryId: number, requirementId: number): Observable<GameJRAnswer> {
    return new Observable<GameJRAnswer>(observer => {
      this.apollo
        .query<{sendGameJRAnswer: GameJRAnswer}>({
          query: SEND_GAME_JR_ANSWER,
          fetchPolicy: "no-cache",
          variables: {
            entryId,
            requirementId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.sendGameJRAnswer);
          observer.complete();
        })
    })
  }

  sendCompanyProfileQuizQuest(clientId: string, profileId: number): Observable<Status> {
    return new Observable<Status>(observer => {
      this.apollo
        .query<{sendCompanyProfileQuizQuest: Status}>({
          query: SEND_COMPANY_PROFILE_QUIZ_QUEST,
          fetchPolicy: "no-cache",
          variables: {
            clientID: clientId,
            profileID: profileId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.sendCompanyProfileQuizQuest);
          observer.complete();
        })
    })
  }

  getGameTrophyHuntSchoolClass(schoolClassId: number): Observable<GameTrophyHuntSchoolClass> {
    return new Observable<GameTrophyHuntSchoolClass>(observer => {
      this.apollo
        .query<{getGameTrophyHuntSchoolClass: GameTrophyHuntSchoolClass}>({
          query: GET_GAME_TROPHY_HUNT_SCHOOL_CLASS,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId: schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getGameTrophyHuntSchoolClass);
          observer.complete();
        })
    })
  }

  getGameTrophyHuntSchoolClassEntry(schoolClassId: number): Observable<GameTrophyHuntSchoolClassEntry> {
    return new Observable<GameTrophyHuntSchoolClassEntry>(observer => {
      this.apollo
        .query<{getGameTrophyHuntSchoolClassEntry: GameTrophyHuntSchoolClassEntry}>({
          query: GET_GAME_TROPHY_HUNT_SCHOOL_CLASS_ENTRY,
          fetchPolicy: "no-cache",
          variables: {
            schoolClassId: schoolClassId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.getGameTrophyHuntSchoolClassEntry);
          observer.complete();
        })
    })
  }

  sendGameTrophyHuntAnswer(entryId: number, resultString: string): Observable<GameTrophyHuntAnswer> {
    return new Observable<GameTrophyHuntAnswer>(observer => {
      this.apollo
        .query<{sendGameTrophyHuntAnswer: GameTrophyHuntAnswer}>({
          query: SEND_GAME_TROPHY_HUNT_ANSWER,
          fetchPolicy: "no-cache",
          variables: {
            entryId,
            resultString
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.sendGameTrophyHuntAnswer);
          observer.complete();
        })
    })
  }

  getRookieTimeslots(districtId: number): Observable<RookieTimeSlot[]> {
    return new Observable<RookieTimeSlot[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_TIME_SLOTS,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieTimeSlots) {
            observer.next(data.rookieTimeSlots);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieProviderRegisterTime(districtId: number): Observable<any> {
    return new Observable<any>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_PROVIDER_REGISTER_TIME,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieProviderRegisterTime) {
            observer.next(data.rookieProviderRegisterTime);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieJobs(districtId: number) {
    return new Observable<ProfessionPreview[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_JOBS,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieJobs) {
            let parsedProfessionPreviews: ProfessionPreview[] = [];

            data?.rookieJobs?.forEach((job: any) => {
              parsedProfessionPreviews.push(this.professionsService.mapRawProfessionPreviewData(job));
            });

            observer.next(parsedProfessionPreviews);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieProviders(districtId: number, schoolId: number) {
    return new Observable<RookieProvider[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_PROVIDERS,
          fetchPolicy: "no-cache",
          variables: {
            districtId,
            schoolId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieProviders) {

            let rookieProviders: RookieProvider[] = [];
            data.rookieProviders.forEach((rawProfile: any) => {
              let rookieProvider: RookieProvider = {
                ...rawProfile
              }
              if(!rawProfile.companyProfilePicture) rookieProvider.companyProfilePicture = {
                contentType: "IMAGE",
                id: 0,
                name: "",
                position: 0,
                image: null,
                video: null,
                document: null,
                visible: false
              };
              if(!rawProfile.companyProfilePicture?.image && rookieProvider.companyProfilePicture) {
                // copy instead of mutating, the media object may be shared with the Apollo cache
                rookieProvider.companyProfilePicture = {
                  ...rookieProvider.companyProfilePicture,
                  image: this.imageService.getPlaceholderImageForProviderBackendImage(rawProfile.id)
                };
              }
              rookieProviders.push(rookieProvider);
            });

            observer.next(rookieProviders);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieOfferPreviewsBySchool(districtId: number, schoolId: number) {
    return new Observable<RookieOfferPreview[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_PREVIEWS_BY_SCHOOL,
          fetchPolicy: "no-cache",
          variables: {
            districtId,
            schoolId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferPreviewsBySchool) {
            observer.next(data.rookieOfferPreviewsBySchool);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieOfferPreviewsByTimeSlotIds(districtId: number, timeSlotIds: number[]) {
    return new Observable<RookieOfferPreview[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_PREVIEWS_BY_TIME_SLOTS,
          fetchPolicy: "no-cache",
          variables: {
            districtId,
            timeSlotIds
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferPreviewsByTimeSlots) {
            observer.next(data.rookieOfferPreviewsByTimeSlots);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  rookieOfferTimeSlotsRemainingSlots(districtId: number) {
    return new Observable<any>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_TIME_SLOTS_REMAINING_SLOTS,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferTimeSlotsRemainingSlots) {
            observer.next(data.rookieOfferTimeSlotsRemainingSlots);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieSchools(districtId: number) {
    return new Observable<RookieSchool[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_SCHOOLS,
          fetchPolicy: "cache-first",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieSchools) {
            observer.next(data.rookieSchools);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieOfferTimeSlotMappingById(offerTimeSlotMappingId: number) {
    return new Observable<RookieOfferTimeSlotMapping>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_TIME_SLOT_MAPPING,
          fetchPolicy: "no-cache",
          variables: {
            offerTsMappingId: offerTimeSlotMappingId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferTimeSlotMappingById) {
            observer.next(data.rookieOfferTimeSlotMappingById);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieOfferById(offerId: number, timeSlotId: number) {
    return new Observable<RookieOffer>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_BY_ID,
          fetchPolicy: "no-cache",
          variables: {
            offerId,
            timeSlotId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferById) {
            observer.next(data.rookieOfferById);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieOfferByCode(districtId: number, timeSlotId: number, shortCode: string) {
    return new Observable<RookieOffer>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_BY_CODE,
          fetchPolicy: "no-cache",
          variables: {
            districtId,
            timeSlotId,
            shortCode
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferByCode) {
            observer.next(data.rookieOfferByCode);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next(undefined);
          observer.complete();
        });
    });
  }

  getRookieDistricts() {
    return new Observable<RookieDistrictServer[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_DISTRICTS,
          fetchPolicy: "cache-first"
        })
        .subscribe(({data, loading}) => {
          if (data.rookieDistricts) {
            observer.next(data.rookieDistricts);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieDistrictState(districtId: number): Observable<RookieDistrictState> {
    return new Observable<RookieDistrictState>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_DISTRICT_STATE,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data) {
            observer.next(data.rookieDistrictState);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieDistrictDateRange(districtId: number): Observable<string> {
    return new Observable<string>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_DISTRICT_DATE_RANGE,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data) {
            observer.next(data.rookieDistrictDateRange);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieDayDistricts(): Observable<RookieDayDistrictServer[]> {
    return new Observable<RookieDayDistrictServer[]>(observer => {
      this.apollo
        .query<{rookiedayDistricts: RookieDayDistrictListEntry[] | null}>({
          query: GET_ROOKIE_DAY_DISTRICTS,
          fetchPolicy: "cache-first"
        })
        .subscribe(({data, loading}) => {
          observer.next((data.rookiedayDistricts ?? []).map((district) => ({
            ...district,
            state: district.state as RookieDayDistrictState
          })));
          observer.complete();
        })
    })
  }

  getRookieProfileSuggestions(searchTerm: string) {
    return new Observable<any[]>(observer => {

      this.apollo
        .query<any>({
          query: GET_PROFILES_ROOKIE_SUGGESTIONS,
          fetchPolicy: "no-cache",
          variables: {
            search: searchTerm,
            limit: 20
          }
        })
        .subscribe(({data, loading}) => {
          console.log(data);
          observer.next(data.companyProfileSearch);
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next([]);
          observer.complete();
        });
    });
  }

  getRookieProfileSuggestionDetails(uuid: string) {
    return new Observable<any>(observer => {

      this.apollo
        .query<any>({
          query: GET_PROFILES_ROOKIE_SUGGESTION_DETAILS,
          fetchPolicy: "no-cache",
          variables: {
            uuid
          }
        })
        .subscribe(({data, loading}) => {

          console.log(data);
          if (data.companyProfile) {
            observer.next(data.companyProfile);
          } else {
            observer.next(undefined);
          }
          observer.complete();


        }, (err) => {
          console.warn(err.message);
          observer.next(undefined);
          observer.complete();
        });
    });
  }

  getRookieSchoolClasses(schoolId: number) {
    return new Observable<RookieSchoolClass[]>(observer => {

      this.apollo
        .query<any>({
          query: GET_ROOKIE_SCHOOL_CLASSES,
          fetchPolicy: "no-cache",
          variables: {
            schoolId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieSchoolClasses) {
            observer.next(data.rookieSchoolClasses);
          } else {
            observer.next([]);
          }
          observer.complete();


        }, (err) => {
          console.warn(err.message);
          observer.next([]);
          observer.complete();
        });
    });
  }

  getRookieOfferTimeSlotMappingByCode(districtId: number, shortCode: string) {
    return new Observable<RookieOfferTimeSlotMapping>(observer => {

      this.apollo
        .query<any>({
          query: GET_ROOKIE_OFFER_TIME_SLOT_MAPPING_BY_CODE,
          fetchPolicy: "no-cache",
          variables: {
            districtId,
            shortCode
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookieOfferTimeSlotMappingByCode) {
            observer.next(data.rookieOfferTimeSlotMappingByCode);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next(undefined);
          observer.complete();
        });
    });
  }

  getRookieDaySchools(districtId: number): Observable<RookieDaySchool[]> {
    return new Observable<RookieDaySchool[]>(observer => {
      this.apollo
        .query<{rookiedaySchools: BackendRookieDaySchool[] | null}>({
          query: GET_ROOKIE_DAY_SCHOOLS,
          fetchPolicy: "cache-first",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next((data.rookiedaySchools ?? []).map((school) => ({
            ...school,
            eventDates: school.eventDates ?? []
          })));
          observer.complete();
        })
    })
  }

  rookiedayRegisterScholar(scholarData: {
    districtId: number;
    schoolId: number | null;
    firstName: string;
    lastName: string;
    birthday: string;
    email: string;
    privacyBoxSelected: boolean;
    selectedCompanies: InRookieDayScholarCompany[];
  }): Observable<{ type: string; message: string }> {
    return new Observable<{ type: string; message: string }>(observer => {
      this.apollo
        .mutate<{rookiedayRegisterScholar: Status}>({
          mutation: ROOKIEDAY_REGISTER_SCHOLAR,
          fetchPolicy: "no-cache",
          variables: {
            scholarData
          }
        })
        .subscribe(({data}) => {
          const status = data?.rookiedayRegisterScholar;
          observer.next(status ? {type: status.type, message: status.message ?? ""} : undefined);
          observer.complete();
        });
    });
  }

  rookiedayRegisterCompany(companyData: {
    districtId: number;
    company: {
      companyProfileId: number;
      companyName: string;
      jobIds: number[];
    };
    contacts: {
      firstname: string;
      lastname: string;
      phone: string;
      email: string;
      dateIds: number[];
    }[];
  }): Observable<{ type: string; message: string }> {
    return new Observable<{ type: string; message: string }>(observer => {
      this.apollo
        .mutate<{rookiedayRegisterCompany: Status}>({
          mutation: ROOKIEDAY_REGISTER_COMPANY,
          fetchPolicy: "no-cache",
          variables: {
            companyData
          }
        })
        .subscribe(({data}) => {
          const status = data?.rookiedayRegisterCompany;
          observer.next(status ? {type: status.type, message: status.message ?? ""} : undefined);
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next(undefined);
          observer.complete();
        });
    });
  }

  rookiedaySubmitRecallCard(recallCardData: {
    code: string;
    verifyCode: string;
    timeSlotMappingId: number;
    selectedOption: number;
    interviewDate: string | null;
    interviewTime: string | null;
    companyName: string;
    contactPersonName: string;
    contactEmail: string;
    contactPhone: string;
    notes: string | null;
  }): Observable<{ type: string; message: string } | undefined> {
    return new Observable<{ type: string; message: string } | undefined>(observer => {
      this.apollo
        .mutate<{rookiedaySubmitRecallCard: Status}>({
          mutation: ROOKIEDAY_SUBMIT_RECALL_CARD,
          fetchPolicy: "no-cache",
          variables: {
            recallCardData
          }
        })
        .subscribe(({data}) => {
          const status = data?.rookiedaySubmitRecallCard;
          observer.next(status ? {type: status.type, message: status.message ?? ""} : undefined);
          observer.complete();
        }, (err) => {
          console.warn(err.message);
          observer.next(undefined);
          observer.complete();
        });
    });
  }

  getRookieDayDistrict(districtId: number): Observable<RookieDayDistrict | undefined> {
    return new Observable<RookieDayDistrict | undefined>(observer => {
      this.apollo
        .query<{rookiedayDistrict: BackendRookieDayDistrict | null}>({
          query: GET_ROOKIE_DAY_DISTRICT,
          fetchPolicy: "cache-first",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          const district = data.rookiedayDistrict;
          if (district) {
            observer.next({
              ...district,
              dates: (district.dates ?? []).map((date) => ({
                ...date,
                date: date.date ?? "",
                placeName: date.placeName ?? "",
                placeRoom: date.placeRoom ?? "",
                placeStreet: date.placeStreet ?? "",
                placeZip: date.placeZip ?? "",
                schools: (date.schools ?? []).filter((school): school is NonNullable<typeof school> => school !== null)
              }))
            });
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  /** Company registration window for a Rookie Day district. */
  getRookieDayProviderRegisterTime(districtId: number): Observable<RookieDayRegisterTime> {
    return new Observable<RookieDayRegisterTime>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_DAY_PROVIDER_REGISTER_TIME,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookiedayProviderRegisterTime) {
            observer.next(data.rookiedayProviderRegisterTime);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  /** Student registration window for a Rookie Day district. */
  getRookieDayScholarRegisterTime(districtId: number): Observable<RookieDayRegisterTime> {
    return new Observable<RookieDayRegisterTime>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_DAY_SCHOLAR_REGISTER_TIME,
          fetchPolicy: "no-cache",
          variables: {
            districtId
          }
        })
        .subscribe(({data, loading}) => {
          if (data.rookiedayScholarRegisterTime) {
            observer.next(data.rookiedayScholarRegisterTime);
          } else {
            observer.next(undefined);
          }
          observer.complete();
        })
    })
  }

  getRookieDayProviders(districtId: number, schoolId: number): Observable<BackendRookieDayProvider[]> {
    return new Observable<BackendRookieDayProvider[]>(observer => {
      this.apollo
        .query<{rookiedayProviders: BackendRookieDayProvider[] | null}>({
          query: GET_ROOKIE_DAY_PROVIDERS,
          fetchPolicy: "cache-first",
          variables: {
            districtId,
            schoolId
          }
        })
        .subscribe(({data, loading}) => {
          observer.next(data.rookiedayProviders ?? []);
          observer.complete();
        })
    })
  }

  getRookieDayStudent(code: string, verifyCode: string): Observable<RookieDayStudent | undefined> {
    return new Observable<RookieDayStudent | undefined>(observer => {
      this.apollo
        .query<{rookiedayStudent: BackendRookieDayStudent | null}>({
          query: GET_ROOKIE_DAY_STUDENT,
          fetchPolicy: "no-cache",
          variables: {
            code,
            verifyCode
          }
        })
        .subscribe(({data}) => {
          observer.next(data.rookiedayStudent ?? undefined);
          observer.complete();
        })
    })
  }

  getRookieDayStudentAppointments(code: string, verifyCode: string): Observable<RookieDayAppointment[]> {
    return new Observable<RookieDayAppointment[]>(observer => {
      this.apollo
        .query<{rookiedayStudentAppointments: Pick<BackendRookieDayAppointment, "startAt" | "endAt" | "companyName" | "jobName" | "contactFirstname" | "contactLastname">[] | null}>({
          query: GET_ROOKIE_DAY_STUDENT_APPOINTMENTS,
          fetchPolicy: "no-cache",
          variables: {
            code,
            verifyCode
          }
        })
        .subscribe(({data}) => {
          observer.next(data.rookiedayStudentAppointments ?? []);
          observer.complete();
        })
    })
  }

  getRookieDayContact(code: string, verifyCode: string): Observable<RookieDayContact | undefined> {
    return new Observable<RookieDayContact | undefined>(observer => {
      this.apollo
        .query<{rookiedayContact: BackendRookieDayContact | null}>({
          query: GET_ROOKIE_DAY_CONTACT,
          fetchPolicy: "no-cache",
          variables: {
            code,
            verifyCode
          }
        })
        .subscribe(({data}) => {
          const contact = data.rookiedayContact;
          observer.next(contact ? {...contact, eventDates: contact.eventDates ?? []} : undefined);
          observer.complete();
        })
    })
  }

  getRookieDayContactAppointments(code: string, verifyCode: string): Observable<RookieDayContactAppointment[]> {
    return new Observable<RookieDayContactAppointment[]>(observer => {
      this.apollo
        .query<{rookiedayContactAppointments: Pick<BackendRookieDayAppointment, "startAt" | "endAt" | "eventDateId" | "eventDate" | "timeSlotId" | "timeSlotMappingId" | "jobName" | "schoolName" | "studentId" | "studentAttendanceState" | "studentFirstname" | "studentLastname" | "isCancelled">[] | null}>({
          query: GET_ROOKIE_DAY_CONTACT_APPOINTMENTS,
          fetchPolicy: "no-cache",
          variables: {
            code,
            verifyCode
          }
        })
        .subscribe(({data}) => {
          observer.next(data.rookiedayContactAppointments ?? []);
          observer.complete();
        })
    })
  }

  getRookieDayProviderLogos(districtId: number) {
    return new Observable<any[]>(observer => {
      this.apollo
        .query<any>({
          query: GET_ROOKIE_DAY_PROVIDER_LOGOS,
          fetchPolicy: "cache-first",
          variables: {
            districtId
          }
        })
        .subscribe(({data}) => {
          observer.next(data.rookiedayProvidersByDistrict ?? []);
          observer.complete();
        })
    })
  }

}

